

import React from 'react'

const GoogleMap = () => {
  return (
    <div >
     
        
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.8521598162374!2d77.4439649144073!3d28.634192690758017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfaca814dbb73%3A0x55a4601198a8f008!2sHawaiAdda%20Aerial%20Innovations%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1674648256914!5m2!1sen!2sin"
         width="100%" height="450" style={{border:0}} allowFullScreen="" referrerpolicy="no-referrer-when-downgrade">Map</iframe>
   
    </div>
  )
}

export default GoogleMap
